<div
  class="bg-blueLow rounded-1 p-2 position-relative overflow-hidden"
  [class.proposal-rater__container--invalid]="quote && !quote.meta.valid"
>
  <div class="mb-2">
    <div class="d-flex align-items-center">
      <lui-avatar class="me-2" [color]="productMeta.color" size="48px">
        <mat-icon [svgIcon]="productMeta.icon"></mat-icon>
      </lui-avatar>

      <h5>{{ productMeta.title }}</h5>
    </div>
  </div>

  <formly-form
    [form]="form"
    [fields]="field.props['fields']"
    [model]="field.model"
    [options]="$any(field.options)"
  ></formly-form>

  <div
    *ngIf="quote && quote.meta.valid"
    class="mt-1 p-2 bg-white d-inline-flex rounded-1 w-100 align-items-end"
  >
    <p class="colon" i18n>Annual premium</p>
    <h4 class="ms-1">{{ quote.premium | currency2 : currencyConfig }}</h4>
  </div>

  <button
    class="mt-2"
    luiCab
    iconPosition="start"
    type="button"
    (click)="removed.emit(productId)"
  >
    <ng-container i18n>Remove from quote</ng-container>
    <mat-icon svgIcon="delete"></mat-icon>
  </button>

  <div *ngIf="loading" class="loading-container">
    <lui-loading-overlay></lui-loading-overlay>
  </div>
</div>
<mat-error *ngIf="quote && !quote.meta.valid"
  >* <ng-container i18n>Requirements not met</ng-container></mat-error
>
